export interface paths {
    "/healthcheck": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["HealthCheckController_checkHealth"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/debug/is-dev-mode-allowed": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["DebugController_isDevModeAllowed"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/debug/create-audit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["DebugController_createAudit"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/feedback": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Save the feedback data to the linked Grist database. */
        post: operations["FeedbackController_sendFeedback"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/feedback/account-deleted": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["FeedbackController_sendAccountDeletionFeedback"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/audits": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve list of audits to be displayed on user's dashboard. */
        get: operations["AuditsController_getAuditList"];
        put?: never;
        /** Save a new audit into the database. */
        post: operations["AuditsController_createAudit"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/audits/{uniqueId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve an audit from the database. */
        get: operations["AuditsController_getAudit"];
        /** Update an audit data in the database. */
        put: operations["AuditsController_updateAudit"];
        post?: never;
        /** Delete an audit from the database. */
        delete: operations["AuditsController_deleteAudit"];
        options?: never;
        head?: never;
        /** Update specific fields of an audit in the database. */
        patch: operations["AuditsController_patchAudit"];
        trace?: never;
    };
    "/audits/{uniqueId}/pages/{pageSlug}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["AuditsController_getAuditPageWithResults"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/audits/{uniqueId}/results/examples": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @deprecated */
        post: operations["AuditsController_uploadExampleImage"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/audits/{uniqueId}/notes/files": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["AuditsController_uploadNotesFile"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/audits/editor/images": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["AuditsController_uploadEditorImage"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/audits/{uniqueId}/results/examples/{exampleId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete: operations["AuditsController_deleteExampleImage"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/audits/{uniqueId}/notes/files/{fileId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete: operations["AuditsController_deleteAuditFile"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/audits/{uniqueId}/results": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve the results of an audit (compliance data) from the database. */
        get: operations["AuditsController_getAuditResults"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /** Update the compliance data of an audit. */
        patch: operations["AuditsController_updateAuditResults"];
        trace?: never;
    };
    "/audits/{uniqueId}/publish": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** Flag an audit as "published", completed. */
        put: operations["AuditsController_publishAudit"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/audits/{uniqueId}/duplicate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Fully duplicate an audit. This includes
         *     - the audit metadata (procedure name, auditor name, etc)
         *     - the audited pages
         *     - the RGAA results (status, comment, user impact)
         *       - the example images
         */
        post: operations["AuditsController_duplicateAudit"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/audits/{uniqueId}/exports/csv": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["AuditsController_getCsvExport"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/audits/{uniqueId}/transfer": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: operations["AuditsController_transferAudit"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/reports/{consultUniqueId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get final report data for a particular audit. */
        get: operations["ReportsController_getAuditReport"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/reports/{consultUniqueId}/exports/csv": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get final report data for a particular audit. */
        get: operations["ReportsController_getCsvExport"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/reports/{consultUniqueId}/declaration": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["ReportsController_getAuditAccessibilityStatement"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/audits/{editUniqueId}/statement": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: operations["StatementsController_getAuditStatement"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/audits/{uniqueId}/pages/{slug}/results/{topic}.{criterium}/not-compliant-items": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["NotCompliantItemsController_createItem"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/audits/{uniqueId}/pages/{slug}/results/{topic}.{criterium}/not-compliant-items/{itemId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete: operations["NotCompliantItemsController_deleteItem"];
        options?: never;
        head?: never;
        patch: operations["NotCompliantItemsController_updateItem"];
        trace?: never;
    };
    "/auth/signin": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Login using *username and password*. An authentication token is returned.
         *
         *     The authentication token should be included in HTTP requests using the `Authorization` header.
         *
         *     See: https://swagger.io/docs/specification/authentication/bearer-authentication/
         */
        post: operations["AuthController_signin"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/auth/refresh": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["AuthController_refreshToken"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/auth/account": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete: operations["AuthController_deleteAccount"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/auth/update-password": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: operations["AuthController_updatePassword"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/auth/signup": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create a new user account.
         *
         *     The account is not useable right away, it first needs to be verified.
         *     To do this, an email containing a verification link is sent to the user
         *     mail adress (their username).
         *
         *     This link contains a *verification token* that will be sent to the
         *     `/api/auth/verify` endpoint to activate the account.
         */
        post: operations["CreateAccountController_createAccount"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/auth/resend-verification-email": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["CreateAccountController_resetVarificationEmail"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/auth/verify": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Verify an account by validating the given token. */
        post: operations["CreateAccountController_verifyAccount"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/auth/verified": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Check if account is verified. */
        get: operations["CreateAccountController_isAccountVerified"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/auth/account/request-password-reset": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["PasswordResetController_requestPasswordReset"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/auth/account/reset-password": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["PasswordResetController_resetPassword"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/auth/account/email": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Update the user's email adress. The change is not effective immediately.
         *     The new email adress must first be verified using the
         *     `account/verify-email-update` route.
         */
        put: operations["UpdateEmailController_updateEmail"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/auth/account/resend-email-update-verification-email": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Trigger a new verification email for the email update. */
        post: operations["UpdateEmailController_resendNewEmailVerificationEmail"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/auth/account/verify-email-update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Verify an email adress by receiving the verification token sent the wanted email adress. */
        post: operations["UpdateEmailController_verifyEmailUpdate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/auth/account/cancel-email-update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["UpdateEmailController_cancelEmailUpdate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/auth/account/verified-email-update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Checks if given email is verified for the authenticated user. */
        get: operations["UpdateEmailController_isNewEmailVerified"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/profile": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /** Patch a user profile. */
        patch: operations["ProfileController_patchProfile"];
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        CreateDebugAuditDto: {
            /**
             * @example FULL
             * @enum {string}
             */
            auditType: CreateDebugAuditDtoAuditType;
            /** @example My procedure */
            procedureName: string;
            /**
             * Format: email
             * @example john@audit.com
             */
            auditorEmail: string;
            isComplete: boolean;
            isPristine: boolean;
            fillStatement: boolean;
            /** Format: date-time */
            publicationDate?: string;
        };
        PageDto: {
            id: number;
            order: number;
            name: string;
            url: string;
        };
        TestEnvironmentDto: {
            id: number;
            platform: string;
            operatingSystem: string;
            assistiveTechnology: string;
            browser: string;
        };
        NotesFileDto: {
            id: number;
            originalFilename: string;
            mimetype: string;
            size: number;
            key: string;
            thumbnailKey: string | null;
        };
        AuditorDto: {
            username: string;
            isVerified: boolean;
        };
        AuditDto: {
            /** @enum {string} */
            auditType: CreateDebugAuditDtoAuditType;
            id: number;
            editUniqueId: string;
            consultUniqueId: string;
            procedureName: string;
            transverseElementsPageId: number;
            auditorName: string | null;
            auditorEmail: string | null;
            initiator: string | null;
            transverseElements: string[];
            auditorOrganisation: string | null;
            procedureUrl: string | null;
            contactName: string | null;
            contactEmail: string | null;
            contactFormUrl: string | null;
            technologies: string[];
            tools: string[];
            notCompliantContent: string | null;
            derogatedContent: string | null;
            notInScopeContent: string | null;
            notes: string | null;
            /** Format: date-time */
            creationDate: string | null;
            /** Format: date-time */
            publicationDate: string | null;
            /** Format: date-time */
            editionDate: string | null;
            /** Format: date-time */
            statementPublicationDate: string | null;
            /** Format: date-time */
            statementEditionDate: string | null;
            schemaPluriannuelUrl: string | null;
            planActionUrl: string | null;
            transverseElementsPage: components["schemas"]["PageDto"];
            environments: components["schemas"]["TestEnvironmentDto"][];
            notesFiles: components["schemas"]["NotesFileDto"][];
            pages: components["schemas"]["PageDto"][];
            auditor: components["schemas"]["AuditorDto"] | null;
        };
        NewFeedbackDto: {
            /**
             * @example Moyen
             * @enum {string}
             */
            easyToUse: NewFeedbackDtoEasyToUse;
            /**
             * @example Oui
             * @enum {string}
             */
            easyToUnderstand: NewFeedbackDtoEasyToUse;
            /** @example Très pratique ! */
            feedback: string;
            /** @example Un bouton pour faire ceci ou celà. */
            suggestions: string;
            /** @example Pierre Poljak */
            name?: string;
            /**
             * Format: email
             * @example person@organization.com
             */
            email?: string;
            /**
             * @example [
             *       "Designer",
             *       "Chef de produit"
             *     ]
             */
            occupations?: NewFeedbackDtoOccupations[];
        };
        AccountDeletionFeedbackDto: {
            feedback: string;
            /** @description Token returned by the */
            feedbackToken: string;
        };
        PageElements: {
            multimedia: boolean;
            form: boolean;
            table: boolean;
            frame: boolean;
        };
        CreateAuditPage: {
            /** @example Page de contact */
            name: string;
            /** @example https://example.com/contact */
            url: string;
        };
        CreateAuditDto: {
            pageElements: components["schemas"]["PageElements"];
            pages: components["schemas"]["CreateAuditPage"][];
            /**
             * @example FULL
             * @enum {string}
             */
            auditType: CreateDebugAuditDtoAuditType;
            /** @example My procedure */
            procedureName: string;
            /** @example John Auditor */
            auditorName: string;
            /**
             * Format: email
             * @example john@audit.com
             */
            auditorEmail: string;
        };
        AuditListingItemDto: {
            /** @enum {string} */
            auditType: CreateDebugAuditDtoAuditType;
            /** @enum {string} */
            status: AuditListingItemDtoStatus;
            procedureName: string;
            editUniqueId: string;
            consultUniqueId: string;
            /** Format: date-time */
            creationDate?: string;
            complianceLevel: number;
            estimatedCsvSize: number;
            statementIsPublished: boolean;
            progress: number;
        };
        ExampleImageFileDto: {
            id: number;
            originalFilename: string;
            mimetype: string;
            size: number;
            key: string;
            thumbnailKey: string;
        };
        NotCompliantItemDto: {
            /** @enum {string|null} */
            userImpact: NotCompliantItemDtoUserImpact;
            id: number;
            title: string | null;
            comment: string | null;
            quickWin: boolean;
        };
        CriterionResultDto: {
            /** @enum {string} */
            status: CriterionResultDtoStatus;
            compliantComment: string | null;
            exampleImages: components["schemas"]["ExampleImageFileDto"][];
            notApplicableComment: string | null;
            topic: number;
            criterium: number;
            pageId: number;
            notCompliantItems: components["schemas"]["NotCompliantItemDto"][];
        };
        GetPageWithResultsDto: {
            id: number;
            name: string;
            results: components["schemas"]["CriterionResultDto"][];
        };
        UpdateAuditEnvironment: {
            /** @example Desktop */
            platform: string;
            /** @example Windows */
            operatingSystem: string;
            /** @example JAWS */
            assistiveTechnology: string;
            /** @example Firefox */
            browser: string;
        };
        UpdateAuditPageDto: {
            /** @example Page de contact */
            name: string;
            /** @example https://example.com/contact */
            url: string;
            /** @description Include the page ID in order to update an existing page. */
            id?: number;
        };
        UpdateAuditDto: {
            /** @example https://procedure.government.com */
            procedureUrl: string | null;
            /** @example Ministry of Internet */
            initiator: string | null;
            /** @example WEB AUDIT SARL */
            auditorOrganisation: string | null;
            /** @example John Referent */
            contactName: string | null;
            /**
             * Format: email
             * @example accessibility@procedure.government.com
             */
            contactEmail: string | null;
            /** @example https://procedure.government.com/contact-a11y */
            contactFormUrl: string | null;
            /**
             * @example [
             *       "Firefox devtools",
             *       "Axe"
             *     ]
             */
            tools: string[] | null;
            environments: components["schemas"]["UpdateAuditEnvironment"][];
            /**
             * @example [
             *       "HTML",
             *       "CSS"
             *     ]
             */
            technologies: string[];
            notCompliantContent: string | null;
            derogatedContent: string | null;
            notInScopeContent: string | null;
            notes: string | null;
            /**
             * @example [
             *       "En-tête",
             *       "pied de page",
             *       "bandeau cookies"
             *     ]
             */
            transverseElements: string[];
            pages: components["schemas"]["UpdateAuditPageDto"][];
            /**
             * @example FULL
             * @enum {string}
             */
            auditType: CreateDebugAuditDtoAuditType;
            /** @example My procedure */
            procedureName: string;
            /** @example John Auditor */
            auditorName: string;
            /**
             * Format: email
             * @example john@audit.com
             */
            auditorEmail: string;
        };
        PatchAuditDto: {
            notes: string | null;
        };
        UploadImageDto: {
            /** @example 123 */
            pageId: number;
            /** @example 3 */
            topic: number;
            /** @example 2 */
            criterium: number;
        };
        CriterionResultNotCompliantItem: {
            id?: number;
            title: string | null;
            comment: string | null;
            /** @enum {string|null} */
            userImpact: NotCompliantItemDtoUserImpact;
            quickWin: boolean;
        };
        UpdateResultsItem: {
            pageId: number;
            /** @example 3 */
            topic: number;
            /** @example 2 */
            criterium: number;
            /** @enum {string} */
            status: CriterionResultDtoStatus;
            /** @example Ad culpa cupidatat proident amet ullamco proident proident mollit ipsum enim consectetur consequat labore. */
            compliantComment: string | null;
            /** @example Officia aliquip aute ipsum in eiusmod ea et. */
            notApplicableComment: string | null;
            notCompliantItems?: components["schemas"]["CriterionResultNotCompliantItem"][];
        };
        UpdateResultsDto: {
            data: components["schemas"]["UpdateResultsItem"][];
        };
        DuplicateAuditDto: {
            /** @example My procedure */
            procedureName: string;
        };
        TransferAuditDto: {
            /**
             * Format: email
             * @example name@domaine.com
             */
            newEmail: string;
        };
        ReportNotesFile: {
            originalFilename: string;
            key: string;
            thumbnailKey: string;
            size: number;
            mimetype: string;
        };
        PageSample: {
            id: number;
            number: number;
            order: number;
            name: string;
            url: string;
        };
        Environment: {
            /** @example Mobile */
            platform: string;
            /** @example Windows */
            operatingSystem: string;
            /** @example JAWS */
            assistiveTechnology: string;
            /** @example Firefox */
            browser: string;
        };
        ReportContext: {
            /** @example Pierre Poljak */
            auditorName: string;
            /** @example john-doe@example.com */
            auditorEmail: string | null;
            /** @example Web Audit Services Corp. */
            auditorOrganisation: string;
            technologies: string[];
            samples: components["schemas"]["PageSample"][];
            tools: string[];
            environments: components["schemas"]["Environment"][];
        };
        CriteriaCount: {
            /** @example 106 */
            total: number;
            /** @example 30 */
            compliant: number;
            /** @example 46 */
            notCompliant: number;
            /** @example 12 */
            blocking: number;
            /** @example 76 */
            applicable: number;
            /** @example 30 */
            notApplicable: number;
        };
        RawAndPercentage: {
            /** @example 47 */
            raw: number;
            /** @example 44.34 */
            percentage: number;
        };
        ResultDistribution: {
            compliant: components["schemas"]["RawAndPercentage"];
            notCompliant: components["schemas"]["RawAndPercentage"];
            notApplicable: components["schemas"]["RawAndPercentage"];
        };
        PageResultDistribution: {
            compliant: components["schemas"]["RawAndPercentage"];
            notCompliant: components["schemas"]["RawAndPercentage"];
            notApplicable: components["schemas"]["RawAndPercentage"];
            /** @example Accueil */
            name: string;
        };
        TopicResultDistribution: {
            compliant: components["schemas"]["RawAndPercentage"];
            notCompliant: components["schemas"]["RawAndPercentage"];
            notApplicable: components["schemas"]["RawAndPercentage"];
            /** @example Éléments obligatoires */
            name: string;
        };
        ReportExampleImage: {
            /** @example mon-image.jpg */
            filename: string;
            /** @example audit/xxxx/my-image.jpg */
            key: string;
            /** @example audit/xxxx/my-image_thumbnail.jpg */
            thumbnailKey: string;
        };
        ReportCriterionResult: {
            /**
             * @example NOT_COMPLIANT
             * @enum {string}
             */
            status: CriterionResultDtoStatus;
            /** @example 2 */
            topic: number;
            /** @example 3 */
            criterium: number;
            /** @example 234 */
            pageId: number;
            compliantComment: string | null;
            exampleImages: components["schemas"]["ReportExampleImage"][];
            notApplicableComment: string | null;
            notCompliantItems: components["schemas"]["CriterionResultNotCompliantItem"][];
        };
        AuditReportDto: {
            /** @enum {string} */
            auditType: CreateDebugAuditDtoAuditType;
            /** @description Unique ID used to construct the report URL. */
            consultUniqueId: string;
            contactEmail?: string;
            contactFormUrl?: string;
            procedureInitiator?: string;
            procedureName: string;
            procedureUrl?: string;
            /** Format: date-time */
            creationDate?: string;
            /** Format: date-time */
            publishDate?: string;
            /** Format: date-time */
            updateDate?: string;
            /** Format: date-time */
            statementPublicationDate?: string;
            /** Format: date-time */
            statementEditionDate?: string;
            schemaPluriannuelUrl?: string;
            planActionUrl?: string;
            notCompliantContent?: string;
            derogatedContent?: string;
            notInScopeContent?: string;
            notes?: string;
            notesFiles: components["schemas"]["ReportNotesFile"][];
            context: components["schemas"]["ReportContext"];
            /**
             * @description Rate out of 100%.
             * @example 86
             */
            accessibilityRate: number;
            criteriaCount: components["schemas"]["CriteriaCount"];
            /** @description Global distribution of criteria by result */
            resultDistribution: components["schemas"]["ResultDistribution"];
            /** @description Distribution of criteria by page */
            pageDistributions: components["schemas"]["PageResultDistribution"][];
            /** @description Distribution of criteria by topic */
            topicDistributions: components["schemas"]["TopicResultDistribution"][];
            results: components["schemas"]["ReportCriterionResult"][];
            transverseElements: string[];
        };
        StatementDto: {
            consultUniqueId: string;
            /** Format: date-time */
            editionDate: string | null;
            /** Format: date-time */
            creationDate: string | null;
            /** Format: date-time */
            publicationDate: string | null;
            /** Format: date-time */
            statementEditionDate: string | null;
            /** Format: date-time */
            statementPublicationDate: string | null;
            auditorName: string;
            auditorEmail: string | null;
            auditorOrganisation: string;
            contactEmail: string | null;
            contactFormUrl: string | null;
            procedureInitiator: string | null;
            procedureName: string;
            procedureUrl: string | null;
            accessibilityRate: number;
            notCompliantContent: string | null;
            derogatedContent: string | null;
            notInScopeContent: string | null;
            technologies: string[];
            samples: components["schemas"]["PageDto"][];
            tools: string[];
            environments: components["schemas"]["TestEnvironmentDto"][];
            schemaPluriannuelUrl: string | null;
            planActionUrl: string | null;
        };
        StatementEnvironment: {
            /** @example Desktop */
            platform: string;
            /** @example Windows */
            operatingSystem: string;
            /** @example JAWS */
            assistiveTechnology: string;
            /** @example Firefox */
            browser: string;
        };
        UpdateStatementDto: {
            /** @example Ministry of Internet */
            initiator: string;
            /** @example WEB AUDIT SARL */
            auditorOrganisation: string;
            /** @example https://procedure.government.com */
            procedureUrl: string;
            /** @example John Referent */
            contactName: string | null;
            /**
             * Format: email
             * @example accessibility@procedure.government.com
             */
            contactEmail: string | null;
            /** @example https://procedure.government.com/contact-a11y */
            contactFormUrl: string | null;
            /**
             * @example [
             *       "HTML",
             *       "CSS"
             *     ]
             */
            technologies: string[];
            /**
             * @example [
             *       "Firefox devtools",
             *       "Axe"
             *     ]
             */
            tools: string[];
            environments: components["schemas"]["StatementEnvironment"][];
            notCompliantContent: string | null;
            derogatedContent: string | null;
            notInScopeContent: string | null;
            /** Format: uri */
            schemaPluriannuelUrl: string | null;
            /** Format: uri */
            planActionUrl: string | null;
        };
        CreateNotCompliantItemDto: {
            title?: string | null;
            comment?: string | null;
            /** @enum {string|null} */
            userImpact?: NotCompliantItemDtoUserImpact;
            quickWin?: boolean;
        };
        UpdateNotCompliantItemDto: {
            title?: string | null;
            comment?: string | null;
            /** @enum {string|null} */
            userImpact?: NotCompliantItemDtoUserImpact;
            quickWin?: boolean;
        };
        SigninDto: {
            username: string;
            password: string;
        };
        DeleteAccountDto: {
            password: string;
        };
        DeleteAccountResponseDto: {
            /** @description JWT token to send with feedback, if any. */
            feedbackToken: string;
        };
        UpdatePasswordDto: {
            oldPassword: string;
            newPassword: string;
        };
        CreateAccountDto: {
            /** Format: email */
            username: string;
            password: string;
        };
        ResendVerificationEmailDto: {
            /** Format: email */
            username: string;
        };
        VerifyAccountDto: {
            token: string;
        };
        RequestPasswordResetDto: {
            /** Format: email */
            email: string;
        };
        ResetPasswordDto: {
            newPassword: string;
            token: string;
        };
        UpdateEmailDto: {
            /** Format: email */
            newEmail: string;
            password: string;
        };
        VerifyEmailUpdateDto: {
            token: string;
        };
        PatchProfileDto: {
            name?: string;
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    HealthCheckController_checkHealth: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
        };
    };
    DebugController_isDevModeAllowed: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Display dev mode switch or not */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": boolean;
                };
            };
        };
    };
    DebugController_createAudit: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateDebugAuditDto"];
            };
        };
        responses: {
            /** @description The debug audit has been successfully created. */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuditDto"];
                };
            };
        };
    };
    FeedbackController_sendFeedback: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["NewFeedbackDto"];
            };
        };
        responses: {
            /** @description The record has been successfully created. */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    FeedbackController_sendAccountDeletionFeedback: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AccountDeletionFeedbackDto"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AuditsController_getAuditList: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuditListingItemDto"][];
                };
            };
            /** @description You must authenticate yourself using a bearer token. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AuditsController_createAudit: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateAuditDto"];
            };
        };
        responses: {
            /** @description The audit has been successfully created. */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuditDto"];
                };
            };
        };
    };
    AuditsController_getAudit: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                uniqueId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The audit was found. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuditDto"];
                };
            };
            /** @description The audit does not exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit has been previously deleted */
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AuditsController_updateAudit: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                uniqueId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateAuditDto"];
            };
        };
        responses: {
            /** @description The audit has been successfully updated */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuditDto"];
                };
            };
            /** @description The audit does not exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit has been previously deleted */
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AuditsController_deleteAudit: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                uniqueId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The audit has been successfully deleted. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit does not exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit has been previously deleted */
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AuditsController_patchAudit: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                uniqueId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PatchAuditDto"];
            };
        };
        responses: {
            /** @description The audit has been successfully patched */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit does not exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit has been previously deleted */
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AuditsController_getAuditPageWithResults: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                uniqueId: string;
                pageSlug: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetPageWithResultsDto"];
                };
            };
            /**
             * @description The audit does not exist.
             *
             *     The page or the audit does not exist.
             */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit has been previously deleted */
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AuditsController_uploadExampleImage: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                uniqueId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UploadImageDto"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ExampleImageFileDto"];
                };
            };
            /** @description The audit does not exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit has been previously deleted */
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AuditsController_uploadNotesFile: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                uniqueId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NotesFileDto"];
                };
            };
            /** @description The audit does not exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit has been previously deleted */
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AuditsController_uploadEditorImage: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Key of uploaded image */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
        };
    };
    AuditsController_deleteExampleImage: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                uniqueId: string;
                exampleId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit does not exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit has been previously deleted */
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AuditsController_deleteAuditFile: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                uniqueId: string;
                fileId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /**
             * @description The audit does not exist.
             *
             *     The file or the audit does not exist.
             */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit has been previously deleted */
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AuditsController_getAuditResults: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                uniqueId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CriterionResultDto"][];
                };
            };
            /** @description The audit does not exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit has been previously deleted */
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AuditsController_updateAuditResults: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                uniqueId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateResultsDto"];
            };
        };
        responses: {
            /** @description The audit results have been successfully updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit does not exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit has been previously deleted */
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AuditsController_publishAudit: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                uniqueId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuditDto"];
                };
            };
            /** @description The audit does not exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit has been previously deleted */
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AuditsController_duplicateAudit: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                uniqueId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DuplicateAuditDto"];
            };
        };
        responses: {
            /** @description The audit has been successfully duplicated. */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuditDto"];
                };
            };
            /** @description The audit does not exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit has been previously deleted */
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AuditsController_getCsvExport: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                uniqueId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description An export of the audit results using the CSV format. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit does not exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit has been previously deleted */
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AuditsController_transferAudit: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                uniqueId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["TransferAuditDto"];
            };
        };
        responses: {
            /** @description The audit has been successfully transfered. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuditDto"];
                };
            };
            /** @description Only audit owner can transfer an audit. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit does not exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit has been previously deleted */
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ReportsController_getAuditReport: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                consultUniqueId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The audit was found. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuditReportDto"];
                };
            };
            /** @description The audit does not exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit has been previously deleted. */
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ReportsController_getCsvExport: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                consultUniqueId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The audit was found. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit does not exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit has been previously deleted. */
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ReportsController_getAuditAccessibilityStatement: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                consultUniqueId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The audit was found. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["StatementDto"];
                };
            };
            /** @description The audit does not exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit has been previously deleted. */
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    StatementsController_getAuditStatement: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                editUniqueId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateStatementDto"];
            };
        };
        responses: {
            /** @description The statement was found. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuditDto"];
                };
            };
            /** @description The statement does not exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The statement has been previously deleted. */
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    NotCompliantItemsController_createItem: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                uniqueId: string;
                slug: string;
                topic: string;
                criterium: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateNotCompliantItemDto"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NotCompliantItemDto"];
                };
            };
            /** @description The audit does not exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit has been previously deleted */
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    NotCompliantItemsController_deleteItem: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                uniqueId: string;
                slug: string;
                topic: string;
                criterium: string;
                itemId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit does not exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit has been previously deleted */
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    NotCompliantItemsController_updateItem: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                uniqueId: string;
                slug: string;
                topic: string;
                criterium: string;
                itemId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateNotCompliantItemDto"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NotCompliantItemDto"];
                };
            };
            /** @description The audit does not exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The audit has been previously deleted */
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AuthController_signin: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SigninDto"];
            };
        };
        responses: {
            /** @description Successfully authenticated. */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            /** @description Invalid credentials. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AuthController_refreshToken: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            /** @description You must authenticate yourself using a bearer token. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AuthController_deleteAccount: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DeleteAccountDto"];
            };
        };
        responses: {
            /** @description The account was succesfully deleted. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DeleteAccountResponseDto"];
                };
            };
            /** @description You must authenticate yourself using a bearer token. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AuthController_updatePassword: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdatePasswordDto"];
            };
        };
        responses: {
            /** @description The password was succesfully updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The new password is identical to the old password. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /**
             * @description You must authenticate yourself using a bearer token.
             *
             *     Wrong old password or invalid bearer token.
             */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    CreateAccountController_createAccount: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateAccountDto"];
            };
        };
        responses: {
            /** @description Account successfully created (pending verification). */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description A verified account with this username already exists. */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    CreateAccountController_resetVarificationEmail: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ResendVerificationEmailDto"];
            };
        };
        responses: {
            /** @description Verification email has been resent. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Either no such user exist or the account has already been verified. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    CreateAccountController_verifyAccount: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["VerifyAccountDto"];
            };
        };
        responses: {
            /** @description Account successfully verified. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Invalid verification token. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    CreateAccountController_isAccountVerified: {
        parameters: {
            query: {
                username: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": boolean;
                };
            };
        };
    };
    PasswordResetController_requestPasswordReset: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RequestPasswordResetDto"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    PasswordResetController_resetPassword: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ResetPasswordDto"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    UpdateEmailController_updateEmail: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateEmailDto"];
            };
        };
        responses: {
            /** @description Email update successfully requested. The new email must be confirmed by using the `account/verify-email-update` route. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description You must authenticate yourself using a bearer token. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    UpdateEmailController_resendNewEmailVerificationEmail: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description You must authenticate yourself using a bearer token. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    UpdateEmailController_verifyEmailUpdate: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["VerifyEmailUpdateDto"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    UpdateEmailController_cancelEmailUpdate: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description You must authenticate yourself using a bearer token. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    UpdateEmailController_isNewEmailVerified: {
        parameters: {
            query: {
                email: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": boolean;
                };
            };
            /** @description You must authenticate yourself using a bearer token. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ProfileController_patchProfile: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PatchProfileDto"];
            };
        };
        responses: {
            /** @description The profile has been successfully patched */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description You must authenticate yourself using a bearer token. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
}
export enum CreateDebugAuditDtoAuditType {
    FAST = "FAST",
    COMPLEMENTARY = "COMPLEMENTARY",
    FULL = "FULL"
}
export enum NewFeedbackDtoEasyToUse {
    Oui = "Oui",
    Moyen = "Moyen",
    Non = "Non"
}
export enum NewFeedbackDtoOccupations {
    Designer_ou_lead_ = "Designer (ou lead)",
    D_veloppeur_D_veloppeuse_ou_lead_ = "D\u00E9veloppeur / D\u00E9veloppeuse (ou lead)",
    Chef_Cheffe_de_projet_product_manager_ = "Chef / Cheffe de projet (product manager)",
    Chef_Cheffe_de_produit_product_owner_ = "Chef / Cheffe de produit (product owner)",
    Auditeur_Auditrice_accessibilit_ = "Auditeur / Auditrice accessibilit\u00E9",
    R_f_rent_R_f_rente_accessibilit_ = "R\u00E9f\u00E9rent / R\u00E9f\u00E9rente accessibilit\u00E9",
    Autre = "Autre"
}
export enum AuditListingItemDtoStatus {
    NOT_STARTED = "NOT_STARTED",
    COMPLETED = "COMPLETED",
    IN_PROGRESS = "IN_PROGRESS"
}
export enum NotCompliantItemDtoUserImpact {
    MINOR = "MINOR",
    MAJOR = "MAJOR",
    BLOCKING = "BLOCKING"
}
export enum CriterionResultDtoStatus {
    COMPLIANT = "COMPLIANT",
    NOT_COMPLIANT = "NOT_COMPLIANT",
    NOT_APPLICABLE = "NOT_APPLICABLE",
    NOT_TESTED = "NOT_TESTED"
}
